// useAppConfig.js
import { useState } from "react";
const { OpenAI } = require("openai");

const useAppConfig = () => {
  const [configData, setConfigData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchConfig = async (appName) => {
    if (!appName) return;

    setLoading(true);
    const openai = new OpenAI({
      dangerouslyAllowBrowser: true,
      apiKey:
        "sk-svcacct-stYxhgCKMvjkcwtvaxUKzc47MazGye9T7KFs51YsTL9rgYZrGmZ5dG4imoizHC_cKLET3BlbkFJzZOXCeNWLvzAyFAlqaLvmEv_uGTYjsZRFcOkAb0DjdQwA3i4eQqPt_0CUMFfqnlN9OwA",
    });

    const prompt = `Given an application name, lookup the latest version, find the download link for the Windows x64 (if available, otherwise 32-bit) installer, and appropriate silent install parameters. Return only the following values in this exact format:

    Download URL: [URL]
    Silent Installation Parameters: [Parameters]
    Installer File Name: [File Name]
    Confidence: Value from 1 - 100
    IconURL: A public url to an icon/image for the application (ending in .png, .webp or .svg)

    The confidence value should reflect how certain you are that the download URL and silent installation parameters will work, based on the following criteria:
    
    - **Confidence 100**: The download link is directly from the official website and verified to download the latest version with no further steps, and the silent installation parameters are verified to work.
    - **Confidence 75**: The download link is from a reliable source but not the official website, and the silent installation parameters are likely to work.
    - **Confidence 50**: The download link is available, but the source's reliability is uncertain, or the silent installation parameters may not be accurate.
    - **Confidence 25**: The download link is not verified
    - **Confidence 2**: The application is unknown, or the download link cannot be determined.
    
    For MSI installers, provide only the MSI parameters without "msiexec /i" (e.g., "/qn"). For other installer types, include the full silent installation parameters without the file name.
    
    The download URL should initiate a direct download of the application without requiring any interaction.
    
    Provide no other text or explanation.`;
    

    try {
      const completion = await openai.chat.completions.create({
        model: "gpt-4o-mini",
        messages: [
          { role: "system", content: prompt },
          { role: "user", content: `Application name:"${appName}"` },
        ],
      });

      const apiResponse = completion.choices[0].message.content;
      const downloadURLMatch = apiResponse.match(/Download URL: (.+)/);
      const silentParamsMatch = apiResponse.match(
        /Silent Installation Parameters: (.+)/,
      );
      const installerNameMatch = apiResponse.match(/Installer File Name: (.+)/);
      const confidenceLevelMatch = apiResponse.match(/Confidence: (.+)/);
      const iconUrl = apiResponse.match(/IconURL: (.+)/);
      const response = {
        downloadURL: downloadURLMatch ? downloadURLMatch[1].trim() : "",
        silentParams: silentParamsMatch ? silentParamsMatch[1].trim() : "",
        installerName: installerNameMatch ? installerNameMatch[1].trim() : "",
        confidenceLevel: confidenceLevelMatch ? confidenceLevelMatch[1].trim() : 0,
        iconURL: iconUrl ? iconUrl[1].trim() : 0,
      };

      setConfigData(response);
    } catch (error) {
      console.error("Error fetching configuration:", error);
    } finally {
      setLoading(false);
    }
  };

  return { configData, fetchConfig, loading };
};

export default useAppConfig;
